import React, { useEffect, useState } from 'react'
import { getEmptyParagraph } from 'bxl-editor'
import { Button, message, Modal } from 'antd'
import Loading from '@components/loading'
import { SaveOutlined, SendOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import BrandSelect from '@components/BrandSelect'
import SizeChartEditor from './sizeChartEditor'
import CategorySelect from '../../components/CategorySelect'
import './index.scss'
import { getUserName } from '../../utils/session'
import { showError } from '../../utils/alert'
import { getSizeChartById, updateSizeChart, addSizeChart } from '@services/sizeChartsService'
import SizeChartDataAdapter from './SizeChartDataAdapter'
import { useParams, useHistory } from 'react-router-dom'
import { getSizeChartContentById, createSizeChartEditor, saveSizeChartEditor } from '@services/sizeChartEditorService'
const { confirm } = Modal

const sizeChartDataAdapter = new SizeChartDataAdapter()

function SizeChartEditorPage(props: any) {
  const { id }: any = useParams()
  const history = useHistory()
  const [meta, setMeta] = useState<any>(null)
  const [value, setValue] = useState<any[]>([getEmptyParagraph()])
  const [brandId, setBrandId] = useState<any>(null)
  const [categoryIds, setCategoryIds] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const onClick = () => {
    const lastSavedTime = localStorage.getItem('last_saved_time')
    if (Number.isNaN(lastSavedTime) || Date.now() - Number(lastSavedTime) > 1000 * 60 * 5) {
      // todo socket save
      message.error('没有保存记录，或保存记录过期，请提交前先保存!')
      return
    }
    const error = sizeChartDataAdapter.validate(value)
    if (error) {
      message.error(error)
      return
    }
    confirm({
      title: `确定${ id ? '修改' : '新建' }尺码表吗?`,
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          {id ? <div><strong>id: </strong>{id}</div> : null}
          <div><strong>brandId: </strong>{brandId}</div>
          <div><strong>categoryIds: </strong>{categoryIds?.join(', ')}</div>
        </>
      ),
      onOk: () => {
        const tables = sizeChartDataAdapter.serialize(value)
        // console.log(tables)
        const hide = message.loading('提交中...')
        if (id) {
          // update
          updateSizeChart(id, brandId, categoryIds, tables)
            .then(res => {
              // console.log(res.data)
              setTimeout(() => {
                hide()
                message.success(`尺码表 ${id} 修改成功`)
              }, 500)
            })
            .catch(error => {
              showError(`尺码表 ${id} 修改失败`, error)
              console.error(error)
              hide()
            })
        } else {
          // add
          addSizeChart(brandId, categoryIds, tables)
            .then(res => {
              // console.log(res.data)
              setTimeout(() => {
                hide()
                message.success(`尺码表 ${res.data?.id} ${res.data?.brand} 新建成功`)
                setTimeout(() => {
                  history.goBack()
                }, 500)
              }, 500)
            })
            .catch(e => {
              showError(`尺码表新建失败!`, e)
              console.error(e)
              hide()
            })
        }  
      },
    })
  }

  const onSave = () => {
    if (!value) {
      message.error('content is empty')
      return
    }
    const error = sizeChartDataAdapter.validate(value)
    if (error) {
      message.error(error)
      return
    }
    const hide = message.loading('保存中...')
    if (!meta || !meta.id) {
      createSizeChartEditor(
        brandId,
        categoryIds?.[0],
        getUserName() || '',
        {
          chart: value,
        },
      )
      .then(res => {
        hide()
        message.success('保存成功')
        localStorage.setItem('last_saved_time', `${Date.now()}`)
        // console.log(res)
        setMeta(res.data)
      })
      .catch(e => {
        console.error(e)
        showError(e?.response?.data?.error)
        hide()
      })
    } else {
      saveSizeChartEditor(meta.id, meta.brand_id, meta.category_id, { chart: value })
        .then(res => {
          hide()
          message.success('保存成功')
          localStorage.setItem('last_saved_time', `${Date.now()}`)
          // console.log(res)
          setMeta(res.data)
        })
        .catch(e => {
          console.error(e)
          showError(e?.response?.data?.error)
          hide()
        })
    }
  }

  useEffect(() => {
    // based on sizechart id instead of brandid / categoryIds
    if (!id) return
    setLoading(true)
    getSizeChartById(id)
      .then(res => {
        getSizeChartContentById(res.data.brand, res.data.categoryIds[0])
          .then(({ data }: any) => {
            setLoading(false)
            setMeta(data)
            if (data.content && data.content.chart) {
              setValue(data.content.chart)
            } else if (res.data) {
              const value = sizeChartDataAdapter.deseialize(res.data)
              setValue(value)
            } else if (data.raw) {
              const rawChart = sizeChartDataAdapter.deseialize(data.raw)
              setValue(rawChart)
            }
          })
          .catch(e => {
            console.error(e)
            setLoading(false)
            const value = sizeChartDataAdapter.deseialize(res.data)
            setValue(value)
          })
        // console.log(res.data)
        setBrandId(res.data.brand)
        setCategoryIds(res.data.categoryIds)
      })
      .catch(error => {
        console.error(error)
        setLoading(false)
      })
  }, [id])

  return (
    <div className="size-chart-container">
      <div className="size-chart-form">
        <div>
          <span>Brand: </span>
          <BrandSelect
            value={brandId}
            placeholder="Please select brands"
            onChange={(b) => setBrandId(b)}
          />
        </div>
        <div>
          <span>Category: </span>
          <CategorySelect
            value={categoryIds || undefined}
            multiple
            onChange={categoryIds => { setCategoryIds(categoryIds) }}
          />
        </div>
        <span style={{ flex: 1 }} />
        <Button className="sc-btn" icon={<SaveOutlined />} onClick={onSave}>
          保存
        </Button>
        <Button className="sc-btn" type="primary" icon={<SendOutlined />} onClick={onClick}>
          提交
        </Button>
      </div>
      <div className="size-chart-content">
        {loading && <Loading spinning />}
        {!loading && <SizeChartEditor value={value} onChange={v => setValue(v)} /> }
      </div>
    </div>
  )
}

export default SizeChartEditorPage
